module.exports = __webpack_public_path__ + "img/MGH-Nihonbashi-11.f90d21e6.jpg";